import {SkillSearchConfig} from './skillSearch.types';

export const defaultSkillSearchConfig: SkillSearchConfig = {
  llmWeight: 0.8,
  keywordWeight: 0.2,
  breadcrumbBoost: 0.2,
  minScore: 0.3,
  maxSkills: 3,
  gapThreshold: 0.3,
};
